import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

const Sidebar = props => {

  function tToggle(action) {
    var body = document.body;

    if (action === "remove") {
      body.classList.remove("vertical-collpsed");
      body.classList.add("sidebar-enable");
    } else {
      body.classList.add("vertical-collpsed");
      body.classList.add("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100" onMouseEnter={() => tToggle('remove')} onMouseLeave={() => tToggle('add')}>
          <SidebarContent {...props} />
        </div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
